import { PATH_CASINO, PATH_SPORTS } from '@/routes/paths'
import { IRoute } from '@/types'

import CardsIcon from '@/components/icons/cards'
import DicesIcon from '@/components/icons/dices'
import GiftIcon from '@/components/icons/gift'
import HomeIcon from '@/components/icons/home'
import MicIcon from '@/components/icons/mic'
import Mic2Icon from '@/components/icons/mic2'
import PigIcon from '@/components/icons/pig'
import RouletteIcon from '@/components/icons/roulette'
import SlotsMachineIcon from '@/components/icons/slots-machine'

// Sports Icons

import AlpineSkiingIcon from '@/components/icons/sports/alpine-skiing'
import AmericanFootballIcon from '@/components/icons/sports/american-football'
import AutoRacingIcon from '@/components/icons/sports/auto-racing'
import BadmintonIcon from '@/components/icons/sports/badminton'
import BandyIcon from '@/components/icons/sports/bandy'
import BaseballIcon from '@/components/icons/sports/baseball'
import BasketballIcon from '@/components/icons/sports/basketball'
import BoxingIcon from '@/components/icons/sports/boxing'
import ChessIcon from '@/components/icons/sports/chess'
import CricketIcon from '@/components/icons/sports/cricket'
import CyclingIcon from '@/components/icons/sports/cycling'
import DartsIcon from '@/components/icons/sports/darts'
import F1Icon from '@/components/icons/sports/f1'
import FieldHockeyIcon from '@/components/icons/sports/field-hockey'
import FloorballIcon from '@/components/icons/sports/floorball'
import FreestyleWrestlingIcon from '@/components/icons/sports/freestyle-wrestling'
import FutsalIcon from '@/components/icons/sports/futsal'
import GaelicFootballIcon from '@/components/icons/sports/gaelic-football'
import GolfIcon from '@/components/icons/sports/golf'
import HandballIcon from '@/components/icons/sports/handball'
import HurlingIcon from '@/components/icons/sports/hurling'
import LacrosseIcon from '@/components/icons/sports/lacrosse'
import MMAIcon from '@/components/icons/sports/mma'
import MotorbikesIcon from '@/components/icons/sports/motorbikes'
import NascarIcon from '@/components/icons/sports/nascar'
import NetballIcon from '@/components/icons/sports/netball'
import PoliticsIcon from '@/components/icons/sports/politics'
import RugbyLeagueIcon from '@/components/icons/sports/rugby-league'
import RugbyUnionIcon from '@/components/icons/sports/rugby-union'
import SnookerIcon from '@/components/icons/sports/snooker'
import SoccerIcon from '@/components/icons/sports/soccer'
import SpeedwayIcon from '@/components/icons/sports/speedway'
import SquashIcon from '@/components/icons/sports/squash'
import TableTennisIcon from '@/components/icons/sports/table-tennis'
import TennisIcon from '@/components/icons/sports/tennis'
import TvShowsAndMoviesIcon from '@/components/icons/sports/tv-shows-and-movies'
import VolleyballIcon from '@/components/icons/sports/volleyball'
import WaterPoloIcon from '@/components/icons/sports/water-polo'

export const casinoRoutes = [
  {
    id: 'lobby',
    path: PATH_CASINO.lobby,
    name: 'Lobby',
    icon: HomeIcon,
    thumbnail: {
      url: '/originals-thumb.webp',
      blurHash: 'U7DQddSk0g-D8^I:GZ=F3ps.{yWE74=K;*1f',
    },
    subhead: 'pigmo originals',
    hiddenRoute: true,
  },
  {
    id: 'originals',
    path: PATH_CASINO.originals,
    name: 'Originals',
    icon: PigIcon,
    subhead: 'pigmo originals',
    thumbnail: {
      url: '/originals-thumb.webp',
      blurHash: 'U7DQddSk0g-D8^I:GZ=F3ps.{yWE74=K;*1f',
    },
  },
  {
    id: 'slots',
    path: PATH_CASINO.slots,
    name: 'Slots',
    icon: SlotsMachineIcon,
    subhead: 'pigmo originals',
    thumbnail: {
      url: '/slots-thumb.webp',
      blurHash: 'UOR]QP-Bn3-7UVj[Xmoe=soJV[nj{woIVujG',
    },
    categories: ['slots'],
  },
  {
    id: 'live-casino',
    path: PATH_CASINO.liveCasino,
    name: 'Live Casino',
    icon: MicIcon,
    subhead: 'pigmo originals',
    thumbnail: {
      url: '/live-thumb.webp',
      blurHash: 'UGQZxj-S{0$g0fWV.6NJpGfPTHWX_0azMys.',
    },
  },
  {
    id: 'game-shows',
    path: PATH_CASINO.gameShows,
    name: 'Game Shows',
    icon: Mic2Icon,
    subhead: 'pigmo game-shows',
    thumbnail: {
      url: '/game-shows-thumb.webp',
      blurHash: 'U7AcmHxe03fp4Taw_LbD=ojsSqk7_Nof9Ea{',
    },
  },
  {
    id: 'table-games',
    path: PATH_CASINO.tableGames,
    name: 'Table Games',
    icon: DicesIcon,
    subhead: 'pigmo originals',
    thumbnail: {
      url: '/table-games-thumb.webp',
      blurHash: 'UDKZ_|$P8^#:0dR*t,X8}ZjZv~oL?boLQ-ay',
    },
    categories: ['card', 'roulette', 'craps', 'table-games'],
  },
  {
    id: 'blackjack',
    path: PATH_CASINO.blackjack,
    name: 'Blackjack',
    icon: CardsIcon,
    subhead: 'pigmo originals',
    thumbnail: {
      url: '/blackjack-thumb.webp',
      blurHash: 'UVG,eno#01kE}*e.9tj[Die.%KkC58a}$%f6',
    },
    categories: ['blackjack'],
  },
  {
    id: 'roulette',
    path: PATH_CASINO.roulette,
    name: 'Roulette',
    icon: RouletteIcon,
    subhead: 'pigmo originals',
    thumbnail: {
      url: '/roulette-thumb.webp',
      blurHash: 'UIJWzB$jRPwd0xjFtRj[}Gofaeay-CSfR*bH',
    },
    categories: ['roulette'],
  },
  {
    id: 'new-releases',
    path: PATH_CASINO.newReleases,
    name: 'New Releases',
    icon: GiftIcon,
    subhead: 'pigmo new-releases',
    thumbnail: {
      url: '/new-releases-thumb.webp',
      blurHash: 'UDDU9ntR00Ns~pj]9ta_N_WD%2t65QWC=ys:',
    },
  },
]

export const sportsRoutes: IRoute[] = [
  {
    id: 'lobby',
    path: PATH_SPORTS.root,
    name: 'Lobby',
    icon: PigIcon,
    hiddenRoute: true,
  },

  {
    id: 'table-tennis',
    path: PATH_SPORTS.tableTennis,
    name: 'Table Tennis',
    icon: TableTennisIcon,
    subhead: 'champions',
    live: true,
    thumbnail: { url: '/soccer-thumb.png' },
  },
  {
    id: 'volleyball',
    path: PATH_SPORTS.volleyball,
    name: 'Volleyball',
    icon: VolleyballIcon,
    subhead: 'champions',
    live: true,
    thumbnail: { url: '/football-thumb.png' },
  },
  {
    id: 'tennis',
    path: PATH_SPORTS.tennis,
    name: 'Tennis',
    icon: TennisIcon,
    subhead: 'champions',
    live: true,
    thumbnail: { url: '/tennis-thumb.png' },
  },
  {
    id: 'soccer',
    path: PATH_SPORTS.soccer,
    name: 'Soccer',
    icon: SoccerIcon,
    subhead: 'champions',
    live: true,
    thumbnail: { url: '/soccer-thumb.png' },
  },
  {
    id: 'basketball',
    path: PATH_SPORTS.basketball,
    name: 'Basketball',
    icon: BasketballIcon,
    subhead: 'champions',
    live: true,
    thumbnail: { url: '/basketball-thumb.png' },
  },
  {
    id: 'rugby-league',
    path: PATH_SPORTS.rugbyLeague,
    name: 'Rugby League',
    icon: RugbyLeagueIcon,
    subhead: 'champions',
    live: true,
    thumbnail: { url: '/rugby-league-thumb.png' },
  },
  {
    id: 'rugby-union',
    path: PATH_SPORTS.rugbyUnion,
    name: 'Rugby Union',
    icon: RugbyUnionIcon,
    subhead: 'champions',
    live: true,
    thumbnail: { url: '/rugby-union-thumb.png' },
  },
  {
    id: 'boxing',
    path: PATH_SPORTS.boxing,
    name: 'Boxing',
    icon: BoxingIcon,
    subhead: 'champions',
    live: true,
    thumbnail: { url: '/basket-thumb.png' },
  },
  {
    id: 'golf',
    path: PATH_SPORTS.golf,
    name: 'Golf',
    icon: GolfIcon,
    subhead: 'champions',
    live: true,
    thumbnail: { url: '/golf-thumb.png' },
  },
  {
    id: 'mma',
    path: PATH_SPORTS.mma,
    name: 'MMA',
    icon: MMAIcon,
    subhead: 'champions',
    live: true,
    thumbnail: { url: '/hockey-thumb.png' },
  },
  {
    id: 'snooker',
    path: PATH_SPORTS.snooker,
    name: 'Snooker',
    icon: SnookerIcon,
    subhead: 'champions',
    live: true,
    thumbnail: { url: '/baseball-thumb.png' },
  },

  {
    id: 'alpine-skiing',
    path: PATH_SPORTS.alpineSkiing,
    name: 'Alpine Skiing',
    icon: AlpineSkiingIcon,
    subhead: 'champions',
    live: true,
    thumbnail: { url: '/alpine-skiing-thumb.png' },
  },
  // {
  //   id: 'ice-hockey',
  //   path: PATH_SPORTS.iceHockey,
  //   name: 'Ice Hockey',
  //   icon: IceHockeyIcon,
  //   subhead: 'champions',
  //   live: true,
  //   thumbnail: { url: '/ice-hockey-thumb.png' },
  // },
  {
    id: 'american-football',
    path: PATH_SPORTS.americanFootball,
    name: 'American Football',
    icon: AmericanFootballIcon,
    subhead: 'champions',
    live: true,
    thumbnail: { url: '/american-football-thumb.png' },
  },
  {
    id: 'f1',
    path: PATH_SPORTS.f1,
    name: 'F1',
    icon: F1Icon,
    subhead: 'champions',
    live: true,
    thumbnail: { url: '/f1-thumb.png' },
  },
  {
    id: 'field-hockey',
    path: PATH_SPORTS.fieldHockey,
    name: 'Field Hockey',
    icon: FieldHockeyIcon,
    subhead: 'champions',
    live: true,
    thumbnail: { url: '/field-hockey-thumb.png' },
  },
  {
    id: 'badminton',
    path: PATH_SPORTS.badminton,
    name: 'Badminton',
    icon: BadmintonIcon,
    subhead: 'champions',
    live: true,
    thumbnail: { url: '/badminton-thumb.png' },
  },
  {
    id: 'baseball',
    path: PATH_SPORTS.baseball,
    name: 'Baseball',
    icon: BaseballIcon,
    subhead: 'champions',
    live: true,
    thumbnail: { url: '/baseball-thumb.png' },
  },
  {
    id: 'cricket',
    path: PATH_SPORTS.cricket,
    name: 'Cricket',
    icon: CricketIcon,
    subhead: 'champions',
    live: true,
    thumbnail: { url: '/cricket-thumb.png' },
  },
  {
    id: 'auto-racing',
    path: PATH_SPORTS.autoRacing,
    name: 'Auto Racing',
    icon: AutoRacingIcon,
    subhead: 'champions',
    live: true,
    thumbnail: { url: '/auto-racing-thumb.png' },
  },
  {
    id: 'water-polo',
    path: PATH_SPORTS.waterPolo,
    name: 'Water Polo',
    icon: WaterPoloIcon,
    subhead: 'champions',
    live: true,
    thumbnail: { url: '/water-polo-thumb.png' },
  },
  {
    id: 'chess',
    path: PATH_SPORTS.chess,
    name: 'Chess',
    icon: ChessIcon,
    subhead: 'champions',
    live: true,
    thumbnail: { url: '/chess-thumb.png' },
  },
  {
    id: 'bandy',
    path: PATH_SPORTS.bandy,
    name: 'Bandy',
    icon: BandyIcon,
    subhead: 'champions',
    live: true,
    thumbnail: { url: '/bandy-thumb.png' },
  },
  {
    id: 'cycling',
    path: PATH_SPORTS.cycling,
    name: 'Cycling',
    icon: CyclingIcon,
    subhead: 'champions',
    live: true,
    thumbnail: { url: '/cycling-thumb.png' },
  },
  {
    id: 'darts',
    path: PATH_SPORTS.darts,
    name: 'Darts',
    icon: DartsIcon,
    subhead: 'champions',
    live: true,
    thumbnail: { url: '/darts-thumb.png' },
  },
  {
    id: 'motorbikes',
    path: PATH_SPORTS.motorbikes,
    name: 'Motorbikes',
    icon: MotorbikesIcon,
    subhead: 'champions',
    live: true,
    thumbnail: { url: '/motorbikes-thumb.png' },
  },
  {
    id: 'floorball',
    path: PATH_SPORTS.floorball,
    name: 'Floorball',
    icon: FloorballIcon,
    subhead: 'champions',
    live: true,
    thumbnail: { url: '/floorball-thumb.png' },
  },
  {
    id: 'freestyle-wrestling',
    path: PATH_SPORTS.freestyleWrestling,
    name: 'Freestyle Wrestling',
    icon: FreestyleWrestlingIcon,
    subhead: 'champions',
    live: true,
    thumbnail: { url: '/freestyle-wrestling-thumb.png' },
  },
  {
    id: 'handball',
    path: PATH_SPORTS.handball,
    name: 'Handball',
    icon: HandballIcon,
    subhead: 'champions',
    live: true,
    thumbnail: { url: '/handball-thumb.png' },
  },
  {
    id: 'futsal',
    path: PATH_SPORTS.futsal,
    name: 'Futsal',
    icon: FutsalIcon,
    subhead: 'champions',
    live: true,
    thumbnail: { url: '/futsal-thumb.png' },
  },
  {
    id: 'gaelic-football',
    path: PATH_SPORTS.gaelicFootball,
    name: 'Gaelic Football',
    icon: GaelicFootballIcon,
    subhead: 'champions',
    live: true,
    thumbnail: { url: '/gaelic-football-thumb.png' },
  },
  {
    id: 'hurling',
    path: PATH_SPORTS.hurling,
    name: 'Hurling',
    icon: HurlingIcon,
    subhead: 'champions',
    live: true,
    thumbnail: { url: '/hurling-thumb.png' },
  },
  {
    id: 'lacrosse',
    path: PATH_SPORTS.lacrosse,
    name: 'Lacrosse',
    icon: LacrosseIcon,
    subhead: 'champions',
    live: true,
    thumbnail: { url: '/lacrosse-thumb.png' },
  },
  {
    id: 'nascar',
    path: PATH_SPORTS.nascar,
    name: 'NASCAR',
    icon: NascarIcon,
    subhead: 'champions',
    live: true,
    thumbnail: { url: '/nascar-thumb.png' },
  },
  {
    id: 'netball',
    path: PATH_SPORTS.netball,
    name: 'Netball',
    icon: NetballIcon,
    subhead: 'champions',
    live: true,
    thumbnail: { url: '/netball-thumb.png' },
  },
  {
    id: 'politics',
    path: PATH_SPORTS.politics,
    name: 'Politics',
    icon: PoliticsIcon,
    subhead: 'champions',
    live: true,
    thumbnail: { url: '/politics-thumb.png' },
  },
  {
    id: 'speedway',
    path: PATH_SPORTS.speedway,
    name: 'Speedway',
    icon: SpeedwayIcon,
    subhead: 'champions',
    live: true,
    thumbnail: { url: '/speedway-thumb.png' },
  },
  {
    id: 'squash',
    path: PATH_SPORTS.squash,
    name: 'Squash',
    icon: SquashIcon,
    subhead: 'champions',
    live: true,
    thumbnail: { url: '/squash-thumb.png' },
  },
  {
    id: 'tv-shows-and-movies',
    path: PATH_SPORTS.tvShowsAndMovies,
    name: 'TV Shows and Movies',
    icon: TvShowsAndMoviesIcon,
    subhead: 'champions',
    live: true,
    thumbnail: { url: '/tv-shows-and-movies-thumb.png' },
  },
]

export const platformRoutes: IRoute[] = [
  {
    id: 'about',
    name: 'About',
    icon: null,
  },
  {
    id: 'support',
    name: 'Support',
    icon: null,
  },
  {
    id: 'provably-fair',
    path: '/provably-fair',
    name: 'Provably Fair',
    icon: null,
  },
]

export const policyRoutes: IRoute[] = [
  {
    id: 'terms-and-conditions',
    path: '/terms-and-conditions',
    name: 'Terms and Conditions',
    icon: null,
  },
  {
    id: 'self-exclusion',
    path: '/self-exclusion',
    name: 'Self Exclusion',
    icon: null,
  },
  {
    id: 'privacy-policy',
    path: '/terms-and-conditions',
    name: 'Privacy Policy',
    icon: null,
  },
  {
    id: 'responsible-gambling',
    path: '/responsible-gambling',
    name: 'Responsible Gambling',
    icon: null,
  },
]
